import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id')({
  beforeLoad: () => getTitleContextSlice('Edit Dashboard'),
  staticData: {
    owner: CodeOwner.Analytics,
  },
});
